import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {Translate} from 'react-localize-redux';
import SlickSlider from "react-slick";
import {Loading} from "../components/Layout";
import background from "../images/bg_horaire.png";

const Block = styled.div`
`;

const Detail = styled.div`
    height: 1500px;
    margin: 40% 10%;
    text-align: center;

    h2 {
        font-size: 60px;
        font-family: 'MuseoSans-700';
        color: ${props => props.theme.navDefault}};
    }
`;

const DetailDescription = styled.div`
    text-align: center;
    font-size: 50px;
    margin: 10% 5%;
    width: 90%;
    font-family: 'MuseoSans-300';
    color: ${props => props.theme.navHighlight}};
`;


const MenuWrapper = styled.div`
    height: 100%;
    overflow-y: auto;
`;

const StyledSlickSlider = styled(SlickSlider)`
    overflow-y: auto;

    &:focus {
        outline: none;
    }
    .slick-list,
    .slick-track {
        height: 100%;
    }
    .slick-slide {
        width: 100%;
        height: 100%;
    }
    .slick-prev {
        top: auto;
        left: ${(props) => props.theme.scale * 360}px;
    }
    .slick-next {
        top: auto;
        right: ${(props) => props.theme.scale * 360}px;
    }
`;

const OpeningHours = () => {

    const openinghours = useSelector(state => state.data.openinghours);
    const theme = useSelector(state => state.config.theme);
    const dispatch = useDispatch();
    console.log(openinghours)
    let slides = [];

    const style = {
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        width: '100%',
        height: '100%',
    }

    const openinghoursText = (item, i) => {
        let output = "";

        output = (
            <Block>
                <Detail>
                    <div>
                        <h2 dangerouslySetInnerHTML={{__html: item.title}}></h2>
                        <DetailDescription dangerouslySetInnerHTML={{__html: item.description}}></DetailDescription>
                    </div>
                </Detail>
            </Block>
        );
        return output;
    }
    if (openinghours) {
        slides = openinghours.map(
            (item, i) => {
                return openinghoursText(item, i);
            },
        );
    }
    return (
        <MenuWrapper style={style}>
            {openinghours ? (
                <StyledSlickSlider>{slides}</StyledSlickSlider>
            ) : (
                <Loading />
            )}
        </MenuWrapper>
    );
};


export default OpeningHours;